const data = [
  {
    title: "Perspectives on Affordability",
    slug: "affordability",
    tags: [
      "UI/UX",
      "Development",
      "Graphic"
    ],
    year: "2019",
    status: "Completed",
    order: 7,
    def: true,
    info: {
      for: "Institute Without Boundaries",
      outcome: "Website",
      role: "JS Developer, UI/UX Design, Illustrator"
    },
    desc: "Small web quiz with unique outcomes, that teaches what \"affordability\" really means as an ethos.",
    colour: "#FABBA6",
    focus: {
      desc: `Perspectives on Affordability was an exhibition aimed at challenging preconcieved notions surrounding the topic of affordability. Although there were many projects featured at this event, the website I was tasked with creating would be both parts quiz and overview, acting as a portal for additional information regarding the other projects.\nThe feature point, the quiz, was a set of thought provoking yes or no questions that shed light on different situations affected by affordability.`,
      components: ["goals", "gallery", "challenges", "video", "outcomes"],
      goals: {
        content: "Create a visually grabbing and simple interface for use at the exhibition by users of all demographics.\nProvide connections to all other projects featured at the exhibition, including information surrounding each.\nDesign unique outcome categories based on the user's answers, i.e., what kind of persona they match with in reference to their outlook on affordability.",
        img: ["thumb.jpg", "thumb2.jpg"]
      },
      challenges: {
        content: [
          "The content provided is purely text; a lot of text to be specific. This makes desiging an interface that is \"visually grabbing\" difficult, especially when attempting to keep it simple.",
          "Additionally, the goal to have unique outcomes based on the user's answers proved to be less straightforward than the team had thought. Drawing connections between the answers and the outcomes seemed arbitrary."
        ],
        img: ["thumb.jpg"]
      },
      gallery: ["architecture.jpg", "architecture2.jpg", "ux.jpg", "ui.jpg", "logos.jpg"],
      video: "https://www.youtube.com/embed/G-8BDCZ4_QE",
      outcomes: "The website was eventually shown on iPads at the affordability exhibition, allowing attendees to understand different perspectives that exist with respects to affordability, and explore the other projects that they may have not yet seen.\n To combat the issue with unique outcomes, the call from the client was to simply randomize which outcome a user got (there were three options), since the real goal of a unique outcome was shareability. To retain some semblance of consequence, I opted to add in a secondary outcome, which essentially told the user that they should be more open to understanding other perspectives, if they were to answer the majority of questions \"incorrectly\".\nFinally, to keep the UI simple and playful, we used bold text, bright colour combinations, and small but smart animations to keep the user flow simple."
    }
  },
  {
    title: "vari Music Concept",
    slug: "vari",
    tags: [
      "UI/UX",
      "Music"
    ],
    year: "2022",
    status: "Completed",
    order: 1,
    def: false,
    info: {
      for: "Culmination Project",
      outcome: "Prototype & Process Book",
      role: "Research, UI/UX Design"
    },
    desc: "Concept music app which generates a new listening experience each time you play a song.",
    colour: "#ff9e9e",
    focus: {
      desc: `vari is a concept music app that creates new listening experiences each time you play a song, through auto-generated effects and instrumentation.\nEvery song has infinite Variations, defined by a set of Styles such as "moody" or "hyper", each of which provide parameters to guide generations.`,
      link: null,
      components: ["goals", "research", "challenges", "video", "outcomes"],
      goals: {
        content: `To explore the popularity behind mood remixing songs (like "slowed & reverb") and, more grandiously, to explore future musical innovations like AI generated music.\nTo increase the longevity of my favourite songs, or just hear them in a new way.`,
        img: ["thumb.jpg", "thumb2.jpg"]
      },
      research: {
        content: `“Chopped & screwed”, “slowed & reverb”, or “8D audio” are all trending remix styles that are often applied to popular songs, sometimes even accruing more plays than the original. Especially with the advent of popular social media app TikTok, this process of alternate versioning has proven to be worth investigating further.\nAdditionally, I've explored song longevity and the contributing factors to listener burn out. One aspect is "growth" in the sense that a song with greater longevity often also grows on you as a listener. Complexity is a strong contributor to the growth factor.\nIn a similar vein, research also shows that the combination of familiar patterns and unique or unexpected passages leads to peak listening longevity. This notion can be easily extrapolated to the concept of vari.`,
        img: ["14.jpg", "20.jpg", "16.jpg"]
      },
      challenges: {
        content: [
          "Retaining the original feel and intent of a song while also trying to incoporate new elements musical elements is a difficult balance to maintain.",
          "Just in general, creating something that sounds anywhere half-decent is a challenge in and of itself, especially when I don't have full control over what the AI will create.",
          "The technical challenge of learning how to interface with these AI libraries (using Magenta.js) as someone with little to no experience in the specific field. I also find that the docs are hard to follow without prior knowledge."
        ],
        img: ["thumb.jpg"]
      },
      video: "https://www.youtube.com/embed/befgxK2yFls",
      outcomes: `This project original started as "airia Music". I created a design and started developing a rudimentary prototype which used magenta.js to generate effects and instrumentation overtop of an existing song. At the time I hit the extent of my abilities and left the project alone.\nA year or two later I picked up the project again for my culmination project. Rather than split the project into research/design and development, I decided to focus solely on the research and design of the app.\nHere are some of the things I've created.`,
      outcomesLink: [
        {
          title: "View Documents",
          link: "https://drive.google.com/drive/folders/1Z_dP3O_OUHH128grJwg4nn183wVPxRB9?usp=sharing"
        },
        {
          title: "Figma Prototype",
          link: "https://www.figma.com/proto/dKP6WXWgc4xzRTop7NAF6t/vari-Music?page-id=3%3A19&type=design&node-id=36-1390&viewport=464%2C457%2C0.13&t=eHVLQQD7Y6NzDix6-1&scaling=scale-down&starting-point-node-id=36%3A1643&show-proto-sidebar=1&mode=design"
        }
      ]
    }
  },
  {
    title: "Flip Sampler",
    slug: "flip",
    tags: [
      "UI/UX",
      "Graphic",
      "Music"
    ],
    year: "2022",
    status: "Completed & Ongoing Updates",
    order: 2,
    def: true,
    info: {
      for: "Suture Sound Inc.",
      outcome: "Mobile App (Design)",
      role: "UI Design"
    },
    desc: "A powerful sample-based music creation app for iPhone, iPad, and Android, lead by Youtuber Andrew Huang.",
    colour: "#E8DD63",
    focus: {
      desc: `Flip is a sample-based music creation app that attempts to fit a DAW-like (digital audio workstation) experience into mobile devices. The project was spearheaded by Andrew Huang, a prolific Youtuber/musician, and accompanied by three developers and one designer (me).\nThe app is currently live for both iOS and Android.`,
      link: [{
        url: "https://flipsampler.com",
        type: "Explore",
        alert: null,
        title: "App Site"
      }],
      components: ["goals", "research", "challenges", "scroller", "outcomes"],
      goals: {
        content: "The aim of this app was to facilitate fast, exploratory music creation, with a robust feature set -- even when compared to full blown computer programs.\nThis meant easy and fast page navigation to allow users to record their musical ideas without hesitation.\nAdditionally, the app aimed to be usable on iPhones as well as iPads to reach the maximum number of users, which is notable as most robust music creation apps tend to stay on the iPad side of things.",
        img: ["focus/connect.jpg", "focus/sample.jpg"]
      },
      research: {
        content: "To create user-friendly designs that encompass this level of functionality, I looked into both competing apps and full computer based DAWs. Applications like Garageband/Logic Pro highlighted ways in which icons could be used more prevalently in musical applications, where normally, professional level software prefers to be more text-based.",
        img: ["icons.jpg", "sketch.jpg"]
      },
      challenges: {
        content: [
          "The most overarching challenge was creating a DAW-like experience within a mobile format. This meant using icons for complicated functionalities, simplifying professional notations, and emphasizing smart layouts; all while attempting to remain \"easy to use\", even for relative beginners.",
          "As I joined the team a little late, the user experience/flow of the app was essentially already decided on. This meant that most of the impact I could have on usability would be UI based."
        ],
        img: ["thumb.jpg"]
      },
      scroller: "A few screen designs; note that the real in-app screens don't necessarily match these one-to-one.",
      outcomes: "The first ready version of the app has launched as of December 1st 2020 and is receiving generally positive review from critics and users alike. From this point, we are working towards adding new features, bug fixing, and designing for more screen-spaces (larger iPads, new M1 macs, possibly Android, etc.).\nI've spent a lot of time specifically on icons for this project, trying to codify somewhat complicated functions into singular, simple icons. In general, with research and some simplifications, the icons seem to perform well with users.\nMoving forward, I would like to polish small/detailed interactions such as dragging functions and interacting with the piano roll scrollers."
    }
  },
  {
    title: "SoundsUnite",
    slug: "soundsunite",
    tags: [
      "Development",
      "UI/UX",
      "Graphic",
      "Music"
    ],
    year: "2026",
    status: "Ongoing",
    order: 1,
    def: true,
    info: {
      for: "SoundsUnite Canada",
      outcome: "Web-App, Mobile App",
      role: "Fullstack Developer & UI/UX Lead"
    },
    desc: "A cross-platform music-focused ecosystem for learning, creating, discovering, and connecting.",
    colour: "#9fc3e0",
    focus: {
      desc: `SoundsUnite is an interactive online music education and social platform for all. It features an intuitive set of tools that empower all people in the music sphere to learn, create, discover, and connect.\nThere are three key platforms. The SoundsUnite website and mobile app provide the primary experience where users can learn a variety of topics, discover new artists and their work, and connect with others. The SoundsUnite Studio mobile app faciliates creation, providing tools for recording, editing, and mixing your own music. The Organizations portal provides educators and groups an interface to upload and manage content that is distributed to the main platform through their organization.`,
      link: [{
        url: "https://soundsunite.com",
        type: "Explore",
        alert: "Account Required",
        title: "SoundsUnite"
      }],
      components: ["goals", "research", "challenges", "gallery", "text", "video", "outcomes"],
      goals: {
        content: "SoundsUnite aims to provide tools and resources that aid users in their respective musical journies, whether they be beginners or professionals.",
        img: ["focus/learn.jpg", "thumb2.jpg"]
      },
      research: {
        content: "Due to the rapid nature of SoundsUnite's development, we rely on team members' collective experiences in the music industry to drive decisions, rather than conducting our own user research.\nWe avoid re-inventing common practises unnecessarily and focus on the aspects of the platform that are more unique, such as how these individual tentpoles (learning, creation, socialization) can intersect and flow between one another.",
        img: ["desktop-display.jpg", "desktop-display2.jpg", "learn-display.jpg", "discover-display.jpg", "profile-display.jpg", "player-display.jpg"]
      },
      challenges: {
        content: [
          "The scope of the platform is large, positioned as an \"all-in-one\" tool, and with that comes challenges in both design and development.",
          "From a design perspective, trying to provide an intuitive layout for each feature while maintaining low visual complexity quickly can lead to cluttered interfaces. Every addition of a new feature requires us to make room by revisting old features and paring them down visually without sacrificing functionality.",
          "For development, scope-creep lends itself heavily to technical debt and SoundsUnite can easily fall into this trap if not careful. Similar to our design approaches, revisiting prior features while implementing new code is essential to ensure deduplication as much as possible."
        ],
        img: ["thumb.jpg"]
      },
      gallery: ["homepage.jpg", "songpage.jpg", "learnpage.jpg", "organizationpage.jpg", "profilepage.jpg",],
      gallerySpaced: true,
      galleryPhone: true,
      video: "https://www.youtube.com/embed/Cjb3MgZ_JLM",
      text: [{
        title: "Technologies",
        body: `The tech stack at SoundsUnite is large so I'll cover the sections that I regularly interface with.\nStarting with clients, we use React and React Native for our web and mobile apps respectively and this is where most of my time is spent. All of our apps are written in TypeScript and (for the most part) are strongly typed.\nAfter my first year or so I transitioned to more full-stack work, with notable focus on our API and connected services. Technologies here include Express, mongoose, SocketIO, Redis, Ory Keto, RabbitMQ, and Elasticsearch, among others.`,
        link: null,
        img: ["focus/hero.jpg", "focus/dj.jpg"]
      }],
      outcomes: `This project is ongoing so here are a few of the larger tasks I've spearheaded/completed:\nRebuilt the messaging system, utilizing SocketIO, on both client and server-side to increase reliability.\nImplemented infinite scroll functionality by introducing new paginated endpoints (cursor-based) for various feeds, using virtualization to increase performance on the client apps.\nBuilt a multi-media course creator (e-learning) complete with lessons, quizzes, and exams, all of which have complex/dynamic validations.\nImplemented a user-group system using role-based access control to handle creating and editing content, adding/removing members, sending email invites, and more.\nOverhauled our media processing pipelines which uses messaging queues to handle compressing and optimizing images, videos, and audio, including generating metadata such as content tags and audio waveforms.\nCreated a file chunk uploader for user media in order to avoid size limitations and to gracefully handle mid-upload failures.\nLead and managed various small teams of co-op students (3-5), including training, task delegation, peer programming, and general mentoring.,`
    }
  },
  {
    title: "Climate Ready",
    slug: "climate",
    tags: [
      "Development",
    ],
    year: "2022",
    status: "Completed",
    order: 4,
    def: true,
    info: {
      for: "Institute without Boundaries",
      outcome: "2 Websites",
      role: "Developer"
    },
    desc: "Two web experiences focused on climate change and climate migration, based on a strong body of research from students of the 2022 Institute without Boundaries cohort.",
    colour: "#a87ee6",
    focus: {
      desc: `Over the course of the 2021-22 school year, the IwB cohort focused on the topic of climage change, readiness, and migration. During this time two key events took place which required the group to present their body of research; part of that presentation included a digital experience.\nThe two websites here were created at different points in their process, highlighting the extent of their research and analysis through various experiences/interactions.`,
      link: [
        {
          url: "https://iwb-designto.netlify.app/",
          type: "Explore",
          alert: null,
          title: "Connect the Dots"
        },
        {
          url: "https://climate-ready-iwb.netlify.app/",
          type: "Explore",
          alert: null,
          title: "Climate Ready"
        }
      ],
      components: ["goals", "research", "challenges", "text", "gallery", "outcomes"],
      goals: {
        content: `The overall goal of these websites was to display the extent of work that the team had completed over their year. Within the primary focus on climate change, the team had multiple projects with varying objectives and those all needed to be displayed in a way that made sense, including the large body of written content and images that came attached.\nEnsuring usability on all devices was also important, including phones, tablets, laptops, and desktops, as the attendees of the event may choose to use their own devices over the provided ones.\nFinally, the design of interfaces needed to be information first, preferring subtle and simple graphics that didn't take away from the research being shown.`,
        img: ["focus/care4u.jpg", "focus/exhib.jpg"]
      },
      research: {
        content: `All research pertaining to the content of the websites was done completely by the IwB cohort and provided to me already formatted for web. Some discussions took place surrounding topics like information density and text placement, among other things, but these were quickly solved and changes were made.\nFrom the development side, some research was necessary to make decisions on scroll position based layouts and animation libraries. It was something I hadn't done much of prior and I needed to ensure that the team's ideas were feasible given the time span.`,
        img: ["process.jpg", "grow.jpg", "care4u.jpg", "remate.jpg"]
      },
      challenges: {
        content: [
          `Both sites have unconventional interactions and layouts, leading to some major development challenges.`,
          `Primarily, adapting these layouts to be responsive and usuable at all screen sizes, including on a touch screen phone, came with larger overhead than I originally assumed; especially the "Climate Ready" website.`,
          "Sequencing also proved to be a challenge especially with scroll-based events, leading to visual bugs. This was mostly caused by using multiple packages for different simultaneous animations and likely could've been avoided with more early-stage research and testing."
        ],
        img: ["thumb.jpg"]
      },
      text: [
        {
          title: "Technologies",
          body: `React was used for both projects, mostly to continue advancing my experience. For "Connect the Dots", I notably used React Konva (a js canvas wrapper) to handle the rendering of the nodes and connections. A lot of time and logic was given to mapping the element positions proportionately on all screen sizes.\nThe second project "Climate Ready" had much more complex requirements from the client. Using GSAP and various scroll packages, I created a scroll position based experience where an interactive world map was the key focus. This experience contained lots of data, including some complex data visualization, paired with written content and images. This entire experience also needed to be usable on phones, which presented another suite of issues.`,
          link: null,
          img: ["focus/ctd.jpg", "thumb2.jpg"]
        },
      ],
      gallery: ["ctd-m-1.jpg", "ctd-2.jpg", "cr-m-2.jpg", "cr-3.jpg", "cr-m-3.jpg", "cr-1.jpg", "cr-2.jpg"],
      gallerySpaced: true,
      galleryPhone: true,
      outcomes: `Both sites were displayed at their respective exhibitions where attendees could interact with them directly on the supplied computer/tablets, or access the live site on their own devices. They were both live with custom domains, but have since expired.\n"Connect the Dots" was simpler to create and therefore was more successful in a public context. The use of canvas was performant on all modern devices and remained usable on most older devices.\n"Climate Ready" was a much more complex experience to create. In general, I try to avoid heavy scroll-based interactions due to accessibility and performance issues, but it was requested by the team, so we went forward with it. Due to time constraints we couldn't get all the interactions as polished as they should've been, and some minor bugs were still in place when it was made live. Despite this, the experience overall performed well with exhibition attendees and users.`
    }
  },
  {
    title: "Peaklist",
    slug: "peaklist",
    tags: [
      "Development",
      "UX/UI",
      "Graphic"
    ],
    year: "2025",
    status: "Ongoing",
    order: 3,
    def: true,
    info: {
      for: "Personal Project",
      outcome: "Web-app",
      role: "Everything"
    },
    desc: "An app to list and rank all of your favourite things.",
    colour: "#ff0000",
    focus: {
      desc: `An app to list and rank all of your favourite (and least favourite) things.`,
      link: [
        {
          url: "https://peaklist.app",
          type: "Explore",
          alert: null,
          title: "Peaklist"
        },
      ],
      components: ["goals", "research", "challenges", "text", "gallery", "outcomes"],
      goals: {
        content: `There are many platforms out there dedicated to ranking and discussing specific media types like movies, music, books, etc. I wanted a platform where users could share any of the things they encounter in their lives, whether that be those aformentioned media properties, tech, fashion, sports, or really anything they like.\nI believe that the things that someone is most passionate about paint a better picture of who they are than what they often portray through their own words or pictures. It hopefully allows a certain level of freedom in that you don't need to curate yourself so cuttingly (as is common with most social media) but rather just share the things around you that likely take part in shaping who you are.\nFrom a design perspective, I wanted the the interface to be very colourful and lively. In an effort to allow the users more expression, I wanted to have many themeing options available and for the interface to allow those themes to co-exist.`,
        img: ["focus/people-records.jpg", "thumb2.jpg"]
      },
      research: {
        content: `For the most part I looked at how popular content creators who operate in rankings/reviews produce their content. Do they create formal and/or structured content or do they more commonly post in freeform manners? What kind of periodicals/scheduling do they follow?\nFor example, a popular creator reviews music weekly in a "bad, okay, good" format, whereas others may more simply have a "what I listened to this week".`,
        img: ["collection-screen.jpg", "wireframes.jpg", "themes.jpg"]
      },
      challenges: {
        content: [
          'The biggest challenge has been in maintaining functional consistency between the various list types: list, collection, and series. Each list type is similar in their backend structure but not necessarily in the way a user interacts with them.',
          "For instance, in editing, some options/settings take effect instantly whereas others are only staged until the user performs a save. It can be unintuitive to the user on which is taking place.",
          "Additionally, there are complexities added by introducing external APIs for each popular media type. Not only from a development view as each have their own interface, but also from a legal or logisitcal perspective."
        ]
      },
      text: [
        {
          title: "Technologies",
          body: `For this project I used the technologies and tooling I had the most experience with. React and Typescript are used for the frontend, along with Tanstack utilities for key functionalities. NodeJS, Typescript, Mongoose, TSOA, Auth0, and Express are used for the server app. Both are hosted on a VPS using docker to handle building and deploying, while nginx handles routing. Media storage is handled with AWS and data storage is handled with MongoDB.`,
          link: null,
          img: ["focus/mountain.jpg", "thumb3.jpg"]
        },
      ],
      gallery: ["screen1.jpg","screen3.jpg","screen2.jpg","screen4.jpg","screen5.jpg","screen6.jpg","screen7.jpg","screen8.jpg"],
      gallerySpaced: true,
      galleryPhone: true,
      outcomes: `There are still many additions and improvements to be done but, as it stands, Peaklist is production ready and live (though it has never been properly shared with anyone).\nGoing forward I would like to realize my plans for a recommendation feature in the second tab of the bottom navigation, which currently leads to an empty page. Additionally, there are many small design/interaction inconsistencies to address.\nIntroducing more external APIs for auto-filling list items is also planned, but this comes with it's own issues. I haven't put much thought into monetizing a platform like this (aside from sticking ads in it), but any monetization would create conflicts with some of the external API's terms of use.`
    }
  },
  {
    title: "Chase the Ace",
    slug: "chasetheace",
    tags: [
      "Development",
      "UX/UI"
    ],
    year: "2026",
    status: "Ongoing",
    order: 5,
    def: true,
    info: {
      for: "Personal Project",
      outcome: "Web-app",
      role: "Developer & Designer"
    },
    desc: "A simple 3D multiplayer web client for the classic chase the ace card game.",
    colour: "#ff0000",
    focus: {
      desc: `A simple 3D multiplayer web client for the classic chase the ace card game.`,
      link: [
        {
          url: "https://chasetheace.cards",
          type: "Explore",
          alert: null,
          title: "Chase the Ace"
        },
      ],
      components: ["goals", "gallery", "text"],
      goals: {
        content: `I was looking for a simple way to play chase the ace with my friends (virtually) and, upon finding nothing online, I took it as an opportunity to mess around with some new libraries.\nI imagined the game to be 3D and to have a low-poly, cutesy aesthetic, though since I won't be doing any of the 3D modeling myself I'm beholden to the free-to-use assets available to me.`,
        img: ["focus/trees.jpg", "thumb2.jpg"]
      },
      text: [
        {
          title: "Technologies",
          body: `The frontend is again Typescript and React, using React Three Fiber to use three.js in a React environment, along with React Spring for animations.\nTo handle the multiplayer aspects of the game I used Socket.IO for client-server communication and Redis for storing short-term data. There are no accounts or persistent data so no database is needed.\nThe game is hosted on a VPS using docker to handle building and deploying, while nginx handles routing.`,
          link: null,
          img: ["focus/characters.jpg", "thumb3.jpg"]
        },
      ],
      gallery: ["screen1.jpg","screen2.jpg","screen3.jpg","screen4.jpg","screen5.jpg","screen6.jpg","screen7.jpg","screen8.jpg"],
      gallerySpaced: true,
      galleryPhone: true
    }
  },
  {
    title: "Posters and Infographics",
    slug: "illustration",
    tags: [
      "graphic"
    ],
    year: "2020",
    order: 3,
    def: false,
    info: {
      for: "Assorted",
      outcome: "Posters & Digital Art",
      role: "Graphic Design"
    },
    desc: "A collection of posters and infographics I've done over the years.",
    colour: "#FABBA6",
    focus: {
      desc: `A collection of posters and infographics I've done over the years.`,
      components: ["text"],
      text: [
        {
          title: "Green Space in our Cities Poster",
          body: `A poster highlighting the many benefits of green spaces in urban areas.\nThe poster, aside from the text, is a 3D rendered scene.`,
          link: null,
          img: ["isoposterfull.jpg", "thumb.jpg"],
        },
        {
          title: "Bike Sharing Infographic",
          body: `An infographic that shows the expansion of bike-sharing programs in major countries over a 13 year period. The data is recent as of 2014.`,
          link: null,
          img: ["thumb2.jpg", "bikepeople.jpg"],
        },
        {
          title: "Panama Poster",
          body: `A simple poster for the city of Panama, or more precisely the Bio Museo — a museum based in Panama City which serves as a landmark of their culture.`,
          link: null,
          img: ["panama.jpg", "biomuseo.jpg"],
        },
      ],
    }
  },
  {
    id: 102,
    title: "Skillpod",
    slug: "skillpod",
    tags: [
      "Development",
      "UI/UX",
      "Illustration"
    ],
    year: "2019",
    status: "Completed",
    order: 6,
    def: true,
    info: {
      for: "Skillpod",
      outcome: "Prototype Web-App",
      role: "React Developer, UI/UX Design, Illustrator"
    },
    desc: "A soft-skill building web-app that aims to aid users in meeting their skill goals.",
    colour: "#9aa1ed",
    focus: {
      desc: `Skillpod is an executive skills coaching program, aimed at helping individuals improve on reflecting and articulating their experiences in ways that are essential for the modern digital landscape.\nWith the goal of transferring the previously physical program to a digital platform, I and a small team were tasked with the creation of a prototype app (in React), which would be used as a proof-of-concept for future investors.`,
      link: [{
        url: "https://skillpod.netlify.app/",
        type: "Demo",
        alert: "Rough",
        title: "Skillpod"
      }],
      components: ["goals", "research", "gallery", "challenges", "scroller", "outcomes"],
      goals: {
        content: "From the beginning, the client envisioned a couple key characteristics that the final product would contain.\n Visually, the interface should be fun/playful, leaning on a colourful set of pre-existing patterns and combinations. \n Additionally, the core of the experience should be based on specific users goals; i.e., what they want out of Skillpod.",
        img: ["focus/goal.jpg", "thumb2.jpg"]
      },
      research: {
        content: "The research phase of this project followed three key steps.\nThe exploration of Skillpod’s core values, differing professions, and differing locations, where connections between them were used to derive a broad set of personas. This allows for outcomes that are catered to the existing system from the very beginning.\nThe mapping of these personas to different aspects of Skillpod (values, learning styles), in order to determine key needs of the users. These needs then inspired a set of insights.\nThe creation of system flows, based on the insights generated from the previous steps. These flows start to outline a more concrete understanding of the app's architecture.",
        img: ["research1.jpg", "research2.jpg", "research3.jpg"]
      },
      challenges: {
        content: [
          "Preventing \"scope bleed\" and maintaining focus on the important aspects, vs. exploring creative solutions to digitizing a paper program was a difficult balance to maintain, especially within the bounds of our project schedule.",
          "Although the entire app is important to the experience, the actual process of teaching the Skillpod \"excutive skills\" was difficult to digitize in a way that was interesting/would retain user attention, while staying honest to the \"tried and true\" material.",
          "In hindsight, our design research phase focused too much on high-level, or otherwise abstract ideas, becoming more concrete too late down the line. For a project with more time, this would be preferred, but in this case, the client wasn't able to fully conceptualize our ideas, which lead to a messier time when actually building the app."
        ],
        img: ["thumb.jpg"]
      },
      gallery: ["persona.jpg", "mapping-rough.jpg", "mapping.jpg", "flows-rough.jpg", "flows.jpg"],
      scroller: ["Progression of the dashboard; from wireframe to final design."],
      outcomes: "In an honest take of the project, we simply ran out of time due to either poor scheduling, or more likely, scope bleed. This shortage prevented us from spending much needed time on the core experiences of the app, creating more of an attractive shell with well thought flow, rather than an effective learning experience.\n Otherwise, the user research, ideas, and high level architecture we created were all strong in their own right, as well as most elements of the UI and user flow, meeting both goals of a user-goal based experience (building a custom learning pathway based on their goals), and a friendly/colourful UI."
    }
  },
  {
    title: "Festival Signage",
    slug: "kincanada",
    tags: [
      "graphic design"
    ],
    year: "2025",
    order: 2,
    def: false,
    info: {
      for: "Stoney Creek Kinsmen Club",
      outcome: "Signage",
      role: "Designer"
    },
    desc: "Menu signage for the Winona Peach Festival volunteer groups.",
    colour: "#FABBA6",
    focus: {
      desc: `The Stoney Creek Kinsmen take part in the Winona Peach Festival selling Candy Floss and Gluten free sandwiches, among other things. I created these posters and menus to update their booths and to make more clear the products on offer.`,
      components: ["text"],
      text: [
        {
          title: "Pink Menu",
          body: `This menu is for the pink trailer (Big Pink) which sells candy floss, candy apples, and snocones. The menu is magnetic and fits perfectly between the serving windows.\nPrice bubbles are left empty to fill with whiteboard marker.`,
          link: null,
          img: ["pink.jpg", "thumb.jpg"],
        },
        {
          title: "Alternative Food Menu",
          body: `The other offering the club has is the alternative food booth, which provides gluten free and dairy free options for the park.`,
          link: null,
          img: ["thumb2.jpg", "toppings.jpg"],
        },
        {
          title: "Alternative Food Banner",
          body: `A new and large banner for the alternative food booth, making clear what is on offer.`,
          link: null,
          img: ["bannerbooth.jpg", "banner.jpg"],
        },
      ],
    }
  },
  // {
  //   title: "Furniture",
  //   slug: "furniture",
  //   tags: [
  //     "wood-working", "furniture design"
  //   ],
  //   year: "2025",
  //   order: 4,
  //   def: false,
  //   info: {
  //     for: "Personal Project",
  //     outcome: "Furniture",
  //     role: "Designer & Builder"
  //   },
  //   desc: "A collection of furniture pieces I've designed and built over the years.",
  //   colour: "#FABBA6",
  //   focus: {
  //     desc: `A collection of furniture pieces I've designed and built over the years, with help from friends and family of course.`,
  //     components: ["text"],
  //     text: [
  //       {
  //         title: "Green Space in our Cities Poster",
  //         body: `A poster highlighting the many benefits of green spaces in urban areas.\nThe poster, aside from the text, is a 3D rendered scene.`,
  //         link: null,
  //         img: ["thumb.jpg", "thumb.jpg"],
  //       },
  //     ],
  //   }
  // },
]

export default data;